module.exports = __webpack_public_path__ + "static/media/Roboto-Bold.7c181887.ttf";